/**
 * Handles segment preference cookie management for toggle navigation
 * between SMB and Enterprise pages
 */

const COOKIE_NAME = 'segment_preference'

/**
 * Sets a session cookie (no "expires"/"max-age"), so it's cleared when the browser session ends.
 */
function setCookie(name, value) {
  document.cookie =
    `${name}=${value}; ` +
    `path=/; ` +
    `secure; ` +
    `samesite=lax`
}

/**
 * Initializes segment preference cookie handling for hero tabs
 */
export function initSegmentPreference() {
  const heroTabs = document.querySelectorAll('.hero-tabs .tabs .tab')

  if (!heroTabs || heroTabs.length === 0) {
    return
  }

  heroTabs.forEach((tab) => {
    tab.addEventListener('click', function (e) {
      const href = tab.getAttribute('href') || ''

      // Only set cookie when navigating to SMB page
      // Virtual Meetings/Enterprise page doesn't need cookie (experiment always enabled)
      if (href.includes('small-business') || href.includes('/smb/')) {
        setCookie(COOKIE_NAME, 'smb')
      }

      // Allow normal navigation to proceed
    })
  })
}
